import React from 'react'
import Navbar from '../Navbar'
import ScrollToTop from '../ScrollToTop'
import '../css/navpages.css'
export const Magazines = () => {
  return (
    <>
    <Navbar/>

    <ScrollToTop/>
    </>
  )
}
